module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_29.d33bc91a.png";